import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { OrganizationService } from "src/app/Service/organization/organization.service";
import { NotificationService } from 'src/app/Service/notification.service';
import { StandardOutputModel } from 'src/app/ViewModel/StandardOutputModel';
import { ProjectWorkflowStatusService } from 'src/app/Service/ProjectWorkflowStatus/ProjectWorkflowStatus.service';
import { ProjectWorkflowStatusOutputModel, ProjectWorkflowStatusInputModel } from 'src/app/ViewModel/ProjectWorkflowStatus';
import { EditprojectworkflowstatusComponent } from '../dialogs/project-workflow-status-dialog/project-workflow-status-dialog.component';
import { CommonService } from 'src/app/Service/Common.service';
import { BusinessGroupModel } from 'src/app/ViewModel/BusinessGroupModel';
import * as moment from 'moment';



@Component({
  selector: 'app-projectworkflowstatus',
  templateUrl: './projectworkflowstatus.component.html',
  styleUrls: ['./projectworkflowstatus.component.css']
})
export class projectworkflowstatusComponent implements OnInit {
  enableFilter = false;
  enableFullscreen = false;
  memberId !:number;
  groupId !:number;
  projectId!:number;
  businessGroupForm!: FormGroup;
  businessGroups: BusinessGroupModel[] = [];
  public pageSize = [50, 100, 200, {
    text: 'All',
    value: 'all'
  }];
  /**Members list against the business group */
  public ProjectWorkflowStatusList: ProjectWorkflowStatusOutputModel[] = [];
  constructor(private _dialog: MatDialog, private _orgService: OrganizationService, public _formBuilder: FormBuilder,
    private _ProjectWorkStatusService: ProjectWorkflowStatusService, private _notificationService: NotificationService,private  _commonService :CommonService) {

  }
  ngOnInit() {
    this.projectId = this._commonService.getProjectId();
    this.groupId = this._commonService.getLoggedInUserGroupId();
    this.memberId = this._commonService.getLoggedInUserId();
    this.getOrganizationList();
    this.createBusinessGroupForm();
    this.getWorkflowStatusList();
    
  }

  createBusinessGroupForm() {
    this.businessGroupForm = this._formBuilder.group({
      businessGroup: new FormControl('', [Validators.required])
    })
  }
  DefalultbusinessGroup()
  {
    let selectedGroup: BusinessGroupModel = this.businessGroups.filter(x => x.group_Id == this.groupId)[0];
    this.businessGroupForm.get('businessGroup')?.setValue(selectedGroup);
  }
  selectedOrganization(organization: BusinessGroupModel) {
    if (typeof organization === "object")
    {
      this.groupId = organization.group_Id;
      this.getWorkflowStatusList();
    }
  }

  /**
  * Get organization list
  */
  getOrganizationList() {
    this._commonService.getProjectBusinessGroups(this.projectId).subscribe((data: BusinessGroupModel[]) => {
      this.businessGroups = data;
      this.DefalultbusinessGroup();
    });
  }

  /**
* Get workflow status list
*/
  getWorkflowStatusList() {
    this._ProjectWorkStatusService.getProjectWorkflowStatus(this.projectId, this.groupId).subscribe((data: ProjectWorkflowStatusOutputModel[]) => {
      this.ProjectWorkflowStatusList = data;
    });
  }
  // addEdit(member?: ProjectWorkflowStatusOutputModel) {
  // }
  addEdit(data?:any| ProjectWorkflowStatusOutputModel) {
    if (data === undefined)
    data = null;
    const dialogRef = this._dialog.open(EditprojectworkflowstatusComponent, {
      panelClass: 'mat-dialog-primary',
      width: '95%',
      height: '50%',
      data: { ProjectWorkflowobj :data, member: this.memberId,group_Id: this.groupId,project_Id: this.projectId,businessGroups: this.businessGroups, selectedGroup: this.businessGroupForm.get('businessGroup')?.value }
    });
    dialogRef.afterClosed().subscribe((response: StandardOutputModel) => {
      if (response.successCode==200) {
        this._notificationService.showPopup(response.successMessage, "Success");
        this.getWorkflowStatusList();
      }
      else if (response.successCode==500) {
        this._notificationService.showPopup(response.successMessage, "Warning");
      }

    }, err => { });
  }

  

  /**
* Toggle filter
*/
  toggleFilter() {
    this.enableFilter = !this.enableFilter;
  }

  /**
     * Full screen
     */
  toggleFullscreen() {
    this.enableFullscreen = !this.enableFullscreen;
  }
  
  unlock(lock_status: any) {
    return lock_status.lock_status
  }
}